<template>
  <a-modal v-model="visible"
           :maskClosable="false"
           :closable="false"
           width="52%">
    <div slot="title"
         class="modal-title">
      温馨提示
    </div>
    <div class="content">
      <p>请预先准备好以下材料才进行填写：</p>
      <p>1.<span class="color-red">（必需）</span>1寸或2寸免冠正面头像照片，仅支持PNG、JPG、JPEG等图片格式。</p>
      <p>2.<span class="color-red">（必需）</span>身份证正反面扫描件，仅支持PDF、PNG、JPG、JPEG等格式。</p>
      <p>3.<span class="color-red">（必需）</span>学历证书/毕业证书扫描件，仅支持PDF、PNG、JPG、JPEG等格式。</p>
      <p>4.<span class="color-red">（必需）</span>专业技术职称证书扫描件，仅支持PDF、PNG、JPG、JPEG等格式。</p>
      <p>5.&nbsp;&nbsp;国家库、省库专家需准备证明材料（如登录系统后的截图等），仅支持PDF、PNG、JPG、JPEG等格式。</p>
      <p>6.（非必需）职业资格证书等其他资料，仅支持PDF、PNG、JPG、JPEG等格式。</p>
      <p class="mt-5">
        文件大小限制：单个文件不超过2M。
      </p>
    </div>
    <template slot="footer">
      <a-button type="primary"
                @click="()=>visible=false">
        知道了
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'ExpertApplyForTipsModal',
  data () {
    return {
      visible: false,
    }
  },
  created () {
    this.visible = true
  },
}
</script>

<style lang="less" scoped>
.modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.content {
  font-size: 16px;
  .color-red {
    color: red;
  }
}
</style>
